import AllContactsSelectionItem from "app/pages/sales-intelligence/sub-modules/contacts-search/models/table-actions-panel/AllContactsSelectionItem";

import type SelectionDropdown from "../../../../table-actions-panel/models/selection-dropdown/SelectionDropdown";
import type { SelectionDropdownItem } from "../../../../table-actions-panel/models/selection-dropdown-item/types";
import { getItemWithTheBiggestValueOrManual } from "../../../../table-actions-panel/utils/selection-dropdown";
import { CONTACTS_SELECTION_RESULTS_LIMIT } from "../../../constants/actions-panel";
import TopNContactsSelectionItem from "../../../models/table-actions-panel/TopNContactsSelectionItem";

const TOP_N_VALUES = [10, 25, 50, 100, 250, 500, 1000, 5000, 10000];

const exportSelectionDropdown: SelectionDropdown = {
    getInitiallySelectedItem: getItemWithTheBiggestValueOrManual,
    getItems(numberOfResults: number, limit = Number.POSITIVE_INFINITY) {
        if (numberOfResults === 0) {
            return [];
        }

        const maximumValue = Math.min(numberOfResults, limit, CONTACTS_SELECTION_RESULTS_LIMIT);
        const topNValuesLessThanEqualMaximum = TOP_N_VALUES.filter((value) => value <= maximumValue);
        const topNItems: SelectionDropdownItem[] = topNValuesLessThanEqualMaximum.map((value) => {
            return new TopNContactsSelectionItem({ value, id: `top-${value}` });
        });

        if (numberOfResults <= maximumValue) {
            const biggestTopNValue = topNValuesLessThanEqualMaximum.at(-1);

            if (maximumValue > (biggestTopNValue ?? 0)) {
                const allItem: SelectionDropdownItem = new AllContactsSelectionItem(maximumValue);

                return topNItems.concat(allItem);
            }
        }

        return topNItems;
    },
};

export default exportSelectionDropdown;
